import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from '@/App';
import '@/styles/index.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element #root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/*
 * The service worker — §11.5. Production builds only: in development it would
 * intercept Vite's module graph and serve yesterday's HMR chunks, which looks
 * exactly like "my change does nothing".
 *
 * After `load`, so registration never competes with first paint for the
 * connection. public/sw.js is deliberately unbundled — see its header for the
 * update-path reasoning.
 */
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // The app works without it — offline fallback and push are progressive.
    });
  });
}
